import styled from 'styled-components';
import {defaultTheme} from "../../../../styles/themes/default";

interface PayrollExplanationContainerProps {
    actionRequired: boolean
}
export const PayrollExplanationContainer = styled.div<PayrollExplanationContainerProps>`
  margin: 30px 0;
  display: flex;
  justify-content: space-between;
  border-radius: 8px;
  background: ${({actionRequired}) => actionRequired ? defaultTheme.yellow : defaultTheme.blue}
`

export const PayrollExplanationText = styled.div`
    padding: 30px;
    h1{
      color: ${({theme}) => theme.white} !important;
      font-size: 24px;
      margin-bottom: 10px;
      font-weight: 600;
    }
    h2 {
      color: ${({theme}) => theme.white} !important;
      font-size: 16px;
      line-height: 20px;
      font-weight: 500;
      margin-bottom: 10px;
    }
`

export const PayrollExplanationImage = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg {
    height: 230px;
    width: auto;
  }
`
